<template>
	<!-- SYSTEM -->
	<v-layout v-if="message['message-type'] == 'system'" class="justify-center my-3">
		<v-chip style="height: auto">
			<div style="white-space: pre-wrap; word-break: break-word; text-align: center">
				{{ message.translations[domainStore.languagePreference] || message.text }}
			</div>
		</v-chip>
	</v-layout>

	<!-- USER -->
	<div
		v-else
		class="my-3"
		:style="{
			'max-width': '80%',
			width: 'fit-content',
			'margin-left': isMe ? 'auto' : '0',
			'margin-right': isMe ? '0' : 'auto',
			background: isMe ? MY_MESSAGE : USER_MESSAGE,
			'border-radius': '20px',
		}"
		style="position: relative"
	>
		<v-layout
			style="padding: 0.5em"
			:class="{ 'recorded-message': !messageWasTyped && (showRecordedIndicator || debugStore.debugMode) }"
		>
			<MessageContent :message="message" />
		</v-layout>
	</div>
</template>

<script setup lang="ts">
import type { AlternisMessage } from "../../../../store/alternis_new";
import { ref, computed } from "vue";
import { useDomainStore } from "../../../../store/domain";
import MessageContent from "./MessageContent.vue";
import { useDebugStore } from "../../../../store/debug";

const MY_MESSAGE = "#4db6ac66";
const USER_MESSAGE = "#80808044";

const domainStore = useDomainStore();
const debugStore = useDebugStore();

const props = defineProps<{ message: AlternisMessage }>();

const showRecordedIndicator = ref(false);

const isMe = computed(() => props.message.sender === 0);
const messageWasTyped = computed(() => {
	return props.message["message-type"] === "text";
});

window.addEventListener("keydown", (e) => {
	if (e.altKey && domainStore.isEditorOrAdmin) showRecordedIndicator.value = true;
});
window.addEventListener("keyup", (e) => {
	if (!e.altKey) showRecordedIndicator.value = false;
});
</script>

<style scoped lang="scss">
.recorded-message {
	border-radius: 20px;
	background-color: #4c3b8f;
}
</style>
